"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/leaveGuard.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');


var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _store = require('web/store');

/* Gives the user the choice to leave unsaved work behind, then runs go. */


/* The campaign on screen's guard, so any control that would leave it (the
 * page's menu, its sidebar row) asks first (review R800-1). */
const LeaveGuardContext = _react.createContext(new Map())

 const LeaveGuardProvider = ({ children }) => {
  const [guards] = _react.useState.call(void 0, () => new Map())
  return _react2.default.createElement(LeaveGuardContext.Provider, { value: guards, __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}},  children )
}; exports.LeaveGuardProvider = LeaveGuardProvider

/* A campaign page's unsaved-work decision, while it's mounted. */
 const useRegisterLeaveGuard = (campaignKey, guard) => {
  const guards = _react.useContext.call(void 0, LeaveGuardContext)
  _react.useEffect.call(void 0, 
    () => {
      guards.set(campaignKey, guard)
      return () => { if (guards.get(campaignKey) === guard) guards.delete(campaignKey) }
    },
    [guards, campaignKey, guard],
  )
}; exports.useRegisterLeaveGuard = useRegisterLeaveGuard

 const useLeaveGuards = () => _react.useContext.call(void 0, LeaveGuardContext); exports.useLeaveGuards = useLeaveGuards

/* The campaign the URL shows now (its page or its wizard), read when asked
 * rather than when a callback was made (review R800-8). */
 const isCampaignOnScreen = (campaignKey) =>
  _optionalChain([_reactrouterdom.matchPath, 'call', _ => _(_store.history.location.pathname, { path: _routes2.default.BROADCAST.CAMPAIGN_PAGE })
, 'optionalAccess', _2 => _2.params, 'access', _3 => _3.campaignKey]) === campaignKey; exports.isCampaignOnScreen = isCampaignOnScreen
